module.exports = __webpack_public_path__ + "img/cave69.4e6cb25a.jpg";